import React, { ComponentProps, useState, useEffect } from "react";
import "./CountdownIndicator.scss";

interface CountdownIndicatorProps extends ComponentProps<"div"> {
  duration?: number;
  message?: string;
}

function CountdownIndicator({
  duration = 5,
  message = "game starts in",
  className = "",
  ...restProps
}: CountdownIndicatorProps) {
  const [timeLeft, setTimeLeft] = useState(duration * 1000);

  useEffect(() => {
    const startTime = Date.now();
    const totalMs = duration * 1000;
    let animationFrameId: number;

    const update = () => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, totalMs - elapsed);
      setTimeLeft(remaining);

      if (remaining > 0) {
        animationFrameId = requestAnimationFrame(update);
      }
    };

    setTimeLeft(totalMs);
    animationFrameId = requestAnimationFrame(update);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [duration]);

  const progressWidth = (timeLeft / (duration * 1000)) * 100;
  const countdownSeconds = Math.ceil(timeLeft / 1000);

  return (
    <div className={`countdown-indicator ${className}`} {...restProps}>
      <div className="progress" style={{ width: `${progressWidth}%` }} />
      <div className="message slashed-zero">
        <span>{message}</span>
        <span className="time-left">0{countdownSeconds}</span>
      </div>
    </div>
  );
}

export default CountdownIndicator;
